import { Injectable } from '@angular/core';
// import { AngularFireDatabase } from 'angularfire2/database';
// import { AngularFireAuth } from 'angularfire2/auth';
import {MQService} from './mq.service';
// import * as firebase from 'firebase';
import 'rxjs/add/operator/take';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  // messaging = firebase.messaging()
  constructor(private mq: MQService) {
  // constructor(private mq: MQService, private db: AngularFireDatabase, private afAuth: AngularFireAuth) {
    // if ('serviceWorker' in navigator) {
    //   navigator.serviceWorker.addEventListener('message', function(event){
    //       console.log('service worker message received', event.data);
    //   });
    // }
  }
  // constructor( private afAuth: AngularFireAuth) { }
  updateToken(token) {
    // this.mq.notify('firebase-token-updated', {token: token});
    // this.afAuth.authState.take(1).subscribe(user => {
    //   if (!user) {
    //     return;
    //   }
    //   const data = { [user.uid]: token }
    //   this.db.object('users/').update(data)
    // })
  }

  getPermission() {
    // this.messaging.requestPermission()
    //   .then(() => {
    //     console.log('Notification permission granted.');
    //     return this.messaging.getToken()
    //   })
    //   .then(token => {
    //     this.updateToken(token)
    //   })
    //   .catch((err) => {
    //     console.log('Unable to get permission to notify.', err);
    //   });
  }

  receiveMessage() {
    // this.messaging.onMessage((payload) => {
    //   const { data } = payload;
    //   this.mq.notify(`push-msg-received:${data.type}`, payload);
    // });
  }
}
